import { app } from '../../../../../../app';
import { Controller } from './remove-directory.controller';

app.component('companyDirectoryIntegrationManageMainRemove', {
    bindings: {
        companyId: '<',
        directory: '<',
    },
    controller: Controller,
    templateUrl: require('./remove-directory.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/main/remove/remove-directory.component.js